var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagamentoNotaFiscal.documentoId)?_c('span',{staticClass:"text-success mr-2"},[_c('i',{staticClass:"fa fa-external-link fa-lg icon-button",attrs:{"title":"Abrir Nota Fiscal em Nova Aba"},on:{"click":function($event){$event.stopPropagation();return _vm.visualizarNotaFiscal()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }